import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const FooterQRCodeSection = ({ appStoreUrl, playStoreUrl }) => (
  <div className="flex align-items-centert imt-22">
    <div className="flex flex-column align-items-centert justify-content-center text-dark imr-10">
      <QRCodeSVG value={window.location.origin + '/app-redirect'} size={72} />
    </div>
    <div className="flex flex-column justify-content-between text-dark">
      <a className="imb-5" href={appStoreUrl} target="_blank" rel="noreferrer">
        <img src={process.env.REACT_APP_STATIC_URL + 'content/assets/images/appleStore.png'} alt="Apple" height={35} />
      </a>
      <a className="imb-5" href={playStoreUrl} target="_blank" rel="noreferrer">
        <img src={process.env.REACT_APP_STATIC_URL + 'content/assets/images/googlePlay.png'} alt="Google" height={35} />
      </a>
    </div>
  </div>
);

export default FooterQRCodeSection;
